import React, { useContext, useEffect, useRef, useState } from 'react';
import logo from '../assets/brand_Logo1.png';
import { GrSearch } from "react-icons/gr";
import { FaRegCircleUser } from "react-icons/fa6";
import { FaShoppingCart } from "react-icons/fa";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import { setUserDetails } from '../store/userSlice';
import ROLE from '../common/role';
import Context from '../context';

const Header = () => {
  const user = useSelector(state => state?.user?.user);
  const dispatch = useDispatch();
  const [menuDisplay, setMenuDisplay] = useState(false);
  const context = useContext(Context);
  const { cartProductCount } = context || {};
  const [guestCartCount, setGuestCartCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const dropdownRef = useRef(null);

  const URLSearch = new URLSearchParams(location.search);
  const searchQuery = URLSearch.get("q") || "";
  const [search, setSearch] = useState(searchQuery);

  /* ✅ CLOSE MENU ON ROUTE CHANGE */
  useEffect(() => {
    setMenuDisplay(false);
  }, [location.pathname]);

  /* ✅ CLOSE MENU ON OUTSIDE CLICK */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuDisplay(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  //useEffect(() => {
  //  if (!user?._id) {
  //    const cart = JSON.parse(localStorage.getItem("guest_cart") || "[]");
  //    setGuestCartCount(cart.length);
  //  }
  //}, [user]);

  //useEffect(() => {
  //const syncGuestCart = () => {
  //  if (!user?._id) {
  //    const cart = JSON.parse(localStorage.getItem("guest_cart") || "[]");
  //    setGuestCartCount(cart.length);
  //  }
  //};
//
  //window.addEventListener("storage", syncGuestCart);
  //return () => window.removeEventListener("storage", syncGuestCart);
//}, [user]);

//useEffect(() => {
//  const updateGuestCart = () => {
//    if (!user?._id) {
//      const cart = JSON.parse(localStorage.getItem("guest_cart") || "[]");
//      setGuestCartCount(cart.length);
//    }
//    updateGuestCart();
//  };
//
//  window.addEventListener("guest_cart_changed", updateGuestCart);
//  return () => window.removeEventListener("guest_cart_changed", updateGuestCart);
//}, [user]);
useEffect(() => {

  const loadGuestCartCount = () => {
    if (!user?._id) {
      const cart = JSON.parse(localStorage.getItem("guest_cart") || "[]");
      setGuestCartCount(cart.length);
    }
  };

  // run now
  loadGuestCartCount();

  // update when cart changes inside app
  window.addEventListener("guest_cart_changed", loadGuestCartCount);

  // update when cart changes from another tab
  window.addEventListener("storage", loadGuestCartCount);

  return () => {
    window.removeEventListener("guest_cart_changed", loadGuestCartCount);
    window.removeEventListener("storage", loadGuestCartCount);
  };

}, [user]);


  const handleLogout = async () => {
    const fetchData = await fetch(SummaryApi.logout_user.url, {
      method: SummaryApi.logout_user.method,
      credentials: 'include'
    });

    const data = await fetchData.json();

    if (data.success) {
      toast.success(data.message);
      dispatch(setUserDetails(null));
      navigate("/");
    } else {
      toast.error(data.message);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    navigate(value ? `/search?q=${value}` : "/search");
  };

  return (
    <header className='h-20 shadow-md fixed w-full z-40 bg-[#F6F1EC]'>
      <div className='h-full container mx-auto flex items-center justify-between px-4 md:px-6'>

        {/* LOGO */}
        <Link to="/" className="flex items-center">
          <img src={logo} alt="logo" className="h-16 w-32 md:h-20 md:w-40" />
        </Link>

        {/* SEARCH */}
        <div className='hidden lg:flex items-center w-full max-w-sm border border-[#5a3620] rounded-full pl-2'>
          <input
            type='text'
            placeholder='Search products...'
            className='w-full outline-none bg-transparent'
            value={search}
            onChange={handleSearch}
          />
          <div className='min-w-[50px] h-8 bg-[#5a3620] flex items-center justify-center rounded-r-full text-white'>
            <GrSearch />
          </div>
        </div>

        {/* RIGHT ACTIONS */}
        <div className='flex items-center gap-4 md:gap-6'>

          {/* PROFILE */}
          {user?._id && (
            <div className='relative' ref={dropdownRef}>
              <div
                className='text-3xl cursor-pointer'
                onClick={() => setMenuDisplay(prev => !prev)}
              >
                {user.profilePic ? (
                  <img src={user.profilePic} className='w-10 h-10 rounded-full' alt="" />
                ) : (
                  <FaRegCircleUser />
                )}
              </div>

              {menuDisplay && (
                <div className='absolute right-0 top-12 bg-white shadow-lg rounded w-28'>
                  <nav className='flex flex-col text-sm'>
                    {user.role === ROLE.ADMIN && (
                      <Link
                        to="/admin-panel/all-products"
                        className='py-2 text-center hover:bg-slate-100'
                        onClick={() => setMenuDisplay(false)}
                      >
                        Admin Panel
                      </Link>
                    )}
                    <Link
                      to="/my-orders"
                      className='py-2 text-center hover:bg-slate-100'
                      onClick={() => setMenuDisplay(false)}
                    >
                      My Orders
                    </Link>
                  </nav>
                </div>
              )}
            </div>
          )}

          {/* CART */}
          
            <Link to="/cart" className='text-2xl relative'>
              <FaShoppingCart />
              <span className='absolute -top-2 -right-3 bg-[#5a3620] text-white w-5 h-5 rounded-full flex items-center justify-center text-xs'>
                {user?._id ? cartProductCount : guestCartCount}
              </span>
            </Link>
          

          {/* LOGIN / LOGOUT */}
          {user?._id ? (
            <button
              onClick={handleLogout}
              className='px-4 py-1 rounded-full bg-[#5a3620] text-white'
            >
              Logout
            </button>
          ) : (
            <Link
              to="/login"
              className='px-4 py-1 rounded-full bg-[#5a3620] text-white'
            >
              Login
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
